<script lang="ts">
  import type { LeaderboardEntry } from "../../leaderboard/core";
  import type { Translate } from "../i18n";

  const {
    entries,
    status,
    limit = 10,
    t,
  }: {
    entries: readonly LeaderboardEntry[];
    status: "idle" | "loading" | "ready" | "unavailable";
    limit?: number;
    t: Translate;
  } = $props();

  const top = $derived(entries.slice(0, limit));
</script>

{#if status === "loading"}
  <p class="board__note">{t("board.loading")}</p>
{:else if status === "unavailable"}
  <p class="board__note">{t("board.unavailable")}</p>
{:else if top.length === 0}
  <p class="board__note">{t("board.empty")}</p>
{:else}
  <ol class="leaders" aria-label={t("board.title")}>
    {#each top as entry, index (entry.id)}
      <li class="leaders__row">
        <span class="leaders__rank">{index + 1}</span>
        <span class="leaders__name"
          >{entry.playerName ?? t("board.anonymous")}</span
        >
        <span class="leaders__score">{entry.score.toLocaleString()}</span>
      </li>
    {/each}
  </ol>
{/if}

<style>
  .board__note {
    font-size: 0.85rem;
    opacity: 0.7;
  }

  .leaders {
    display: grid;
    gap: 0.1rem;
    width: 100%;
    max-width: 20rem;
    margin: 0;
    padding: 0;
    list-style: none;
    font-variant-numeric: tabular-nums;
  }

  .leaders__row {
    display: grid;
    grid-template-columns: 1.6rem minmax(0, 1fr) auto;
    align-items: baseline;
    gap: 0.5rem;
    padding: 0.16rem 0.2rem;
    font-size: 0.9rem;
    text-align: left;
  }

  .leaders__row:nth-child(odd) {
    background: rgb(242 246 249 / 0.06);
  }

  .leaders__rank {
    opacity: 0.6;
    text-align: right;
  }

  .leaders__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .leaders__score {
    font-weight: 700;
  }
</style>
